import { Box, BlockStack, InlineGrid, InlineStack, Text, Tooltip, Icon, Divider } from "@shopify/polaris";
import { InfoIcon } from "@shopify/polaris-icons";
import ToggleSwitch from "../../../components/ToggleSwitch/ToggleSwitch";
import { BundleTypes } from "../constants";

type Tab = {
    id: string;
    content: string;
    accessibilityLabel: string;
    panelID: string;
    bundles: any[];
};

export const tabs: Tab[] = [
    {
        id: "visibility",
        content: "Visibility",
        accessibilityLabel: "Visibility",
        panelID: "visibility-panel",
        bundles: [BundleTypes.VOLUME_DISCOUNT, BundleTypes.BXGY, BundleTypes.PRODUCT_ADDONS, BundleTypes.MIX_MATCH],
    },
    {
        id: "pricing",
        content: "Pricing",
        accessibilityLabel: "Pricing",
        panelID: "pricing-panel",
        bundles: [
            BundleTypes.VOLUME_DISCOUNT,
            BundleTypes.FBT,
            BundleTypes.STANDARD,
            BundleTypes.MIX_MATCH,
            BundleTypes.MIX_MATCH_SECTIONAL,
            BundleTypes.PRODUCT_ADDONS,
        ],
    },
    {
        id: "selection",
        content: "Selection",
        accessibilityLabel: "Selection",
        panelID: "selection-panel",
        bundles: [BundleTypes.FBT, BundleTypes.PRODUCT_ADDONS, BundleTypes.MIX_MATCH],
    },
    {
        id: "flow-rules",
        content: "Flow & Rules",
        accessibilityLabel: "Flow & Rules",
        panelID: "flow-rules-panel",
        bundles: [BundleTypes.STANDARD],
    },
];
interface SettingRowProps {
    label: string;
    description?: string | any;
    checked: boolean;
    onChange: (val: boolean) => void;
    tooltipContent?: any;
    disabled?: boolean;
    hideDivider?: boolean;
}

const SettingRow = ({
    label,
    description,
    checked,
    onChange,
    tooltipContent,
    disabled = false,
    hideDivider = false,
}: SettingRowProps) => (
    <>
        <Box paddingBlock="400">
            <BlockStack gap="200">
                <InlineGrid columns={{ xs: "1fr auto" }} alignItems="center" gap="400">
                    <BlockStack gap="100">
                        <InlineStack gap="100" align="start">
                            <Text as="span" variant="bodyMd" fontWeight="semibold">
                                {label}
                            </Text>
                            {tooltipContent && (
                                <Tooltip content={tooltipContent} width="wide">
                                    <Icon source={InfoIcon} tone="subdued" />
                                </Tooltip>
                            )}
                        </InlineStack>
                        {description && (
                            <Text as="p" variant="bodyMd" tone="subdued">
                                {description}
                            </Text>
                        )}
                    </BlockStack>
                    <ToggleSwitch disabled={disabled} checked={checked} setToggle={() => onChange(!checked)} zoom={1} />
                </InlineGrid>
            </BlockStack>
        </Box>
        {!hideDivider && <Divider />}
    </>
);

export default SettingRow;
